import * as React from 'react';
import { Modal } from '@leagueplatform/genesis-core';
import { EffectiveTime, InputConfigValue } from '@leagueplatform/dashboard-api';
import { track } from '@leagueplatform/analytics';
import { ParseValueForInput } from '#utils/parse-value-for-input.util.ts';
import { AddEditDataModalContent } from './add-edit-data-modal-content';
import { AddEditDataModalContentContainer } from './add-edit-data-modal-content-container';

type AddEditDataManagedModalProps = {
  opened: boolean;
  onClose: () => void;
  inputConfig: InputConfigValue;
  metricConfigId: string;
  observationId?: string;
  value?: number | string | null;
  label?: string;
  timestamp?: string;
  effectiveDateTime?: EffectiveTime;
};

export function AddEditDataManagedModal({
  opened,
  onClose,
  inputConfig,
  metricConfigId,
  observationId,
  value,
  label,
  timestamp,
  effectiveDateTime,
}: AddEditDataManagedModalProps) {
  React.useEffect(() => {
    if (opened) {
      track('dashboard.screen_loaded.metric_data_entry_screen_metric_type', {
        metric_type: metricConfigId || '',
        metric_id: '',
        metric_status: '',
      });
    }
  }, [metricConfigId, opened]);

  return (
    <Modal.Root
      open={opened}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <AddEditDataModalContentContainer>
        <AddEditDataModalContent
          inputConfig={inputConfig}
          metricConfigId={metricConfigId}
          onSuccessSubmit={() => {
            onClose();
          }}
          values={
            value != null
              ? {
                  effectiveDateTime,
                  timeStamp: timestamp,
                  metrics: [
                    {
                      observationId,
                      value: ParseValueForInput(value, label),
                    },
                  ],
                }
              : undefined
          }
        />
      </AddEditDataModalContentContainer>
    </Modal.Root>
  );
}
